import axios from 'axios';
import { omit } from 'lodash';
import qs from 'qs';

const apiMiddleware = ({ dispatch }) => next => action => {
  if (!action.meta || action.meta.type !== 'api') {
    return next(action);
  }
  const options = Object.assign({}, action.meta.options);

  if (options.method === 'post') {
    if (options.multipart) {
      const data = new FormData();
      Object.getOwnPropertyNames(options.data).forEach(fieldName => {
        data.append(fieldName, options.data[fieldName]);
      });
      options.data = data;
      options.headers = {
        'content-type': 'multipart/form-data',
      };
    } else {
      options.data = qs.stringify(options.data);
    }
  }
  // Make the request
  dispatch({
    type: `${action.type}_REQUEST`,
    params: action.tag.params,
  });
  return axios
    .request(options)
    .then(response => {
      // dispatch the original action without the meta object
      const newAction = Object.assign(omit(action, 'meta'), {
        type: `${action.type}_SUCCESS`,
        payload: response.data,
      });
      dispatch(newAction);
      return response.data;
    })
    .catch(error => {
      console.info(error);
      if (error.response && error.response.status === 400) {
        dispatch({ type: `${action.type}_FAILURE` });
      }
    });
};

export default apiMiddleware;
